export interface ReRenderAutocompleteSearchProp {
  on: () => void;
  off: () => void;
}
export const reRenderComponent = ({ on, off }: ReRenderAutocompleteSearchProp) => {
  off();
  setTimeout(() => {
    on();
  }, 500);
};
